import { h } from "preact";

import Icon from "./Icon.jsx";
import { renderHtml } from "../helpers.js";

export default function EmptyState({ children, icon, title, description }) {
  return (
    <section class="empty-state">
      <Icon class="mt-48 mb-48" big>
        {icon}
      </Icon>

      <h1 class="t-subtitle1 t-subtitle1--margin">{title}</h1>
      <p class="t-body3 mb-48 color-shades-grey">{renderHtml(description)}</p>

      {children && <div class="empty-state__action">{children}</div>}
    </section>
  );
}
